import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// plugins

import { ClipboardModule } from 'ngx-clipboard';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule } from '@ngx-translate/core';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { QrCodeComponent } from 'ng-qrcode';

// components
import { HeaderComponent } from './components/header/v1/header.component';
import { LanguageChangeComponent } from './components/language-change/language-change.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { NotSuitableToIframeComponent } from './components/not-suitable-to-iframe/not-suitable-to-iframe.component';
import { AlertComponent } from './components/alert/alert.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';

// directives
import { LoadingDirective } from '@shared/directives/loading.directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
// pipes
import { ReplaceLineBreaks } from './pipes/replace-line-breaks.pipe';

// pipes
import { BeautifulEnumPipe } from './pipes/beautiful-enum.pipe';
import { HeaderV2Component } from './components/header/v2/header.component';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { CurrencySymbolPipe } from './pipes/currency-symbol.pipe';
import { CryptoNamePipe } from './pipes/crypto-name.pipe';
import { NohrefDirective } from './directives/nohref.directive';

const maskConfig = {
  validation: false,
};

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    NgxPermissionsModule.forChild(),
    GooglePayButtonModule,
    NgxMaskDirective,
    QrCodeComponent,
    TranslateModule,
  ],
  declarations: [
    LoadingDirective,
    ReplaceLineBreaks,
    BeautifulEnumPipe,
    HeaderComponent,
    HeaderV2Component,
    LanguageChangeComponent,
    NotSuitableToIframeComponent,
    NotfoundComponent,
    AlertComponent,
    UnauthorizedComponent,
    PhoneInputComponent,
    OtpInputComponent,
    CurrencyFormatPipe,
    CurrencySymbolPipe,
    CryptoNamePipe,
    NohrefDirective,
  ],
  exports: [
    LoadingDirective,
    ReplaceLineBreaks,
    BeautifulEnumPipe,
    HeaderComponent,
    HeaderV2Component,
    LanguageChangeComponent,
    NotfoundComponent,
    NotSuitableToIframeComponent,
    AlertComponent,
    UnauthorizedComponent,
    PhoneInputComponent,
    OtpInputComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    NgxPermissionsModule,
    GooglePayButtonModule,
    TranslateModule,
    NgxMaskDirective,
    NohrefDirective,
    QrCodeComponent,
    CurrencyFormatPipe,
    CurrencySymbolPipe,
    CryptoNamePipe,
  ],
  providers: [
    provideNgxMask(maskConfig), // Providing NgxMask with config
  ],
})
export class SharedModule {}
